export enum CustomerSiteWorkflowType {
  normal = 'NORMAL',
  light = 'LIGHT',
}
